import React from 'react';
import PropTypes from 'prop-types';
import TextFieldButton from '../../../02_molecules/TextFieldButton';
import FormattedText from '../../../01_atoms/FormattedText';
import { breakpoints } from '../../../../utils/breakpoint';
import {
  behaviorSettingsProps,
  generateClassNameByBehaviorSettings,
} from '../../../../utils/behaviorSettings';

import styles from './index.module.scss';

class BBQuickDonateWidget extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileImageHeight: 0,
    };
  }

  componentDidMount() {
    window.addEventListener('resize', this.handleMobileImageHeight);
    this.handleMobileImageHeight();
  }

  handleMobileImageHeight = () => {
    const width = window.innerWidth;
    const { wrapperSection } = this.props;
    let mobileBreakpoint = breakpoints.md;
    if (wrapperSection === 'twoColumns-main') {
      mobileBreakpoint = breakpoints.xl;
    }

    if (width < mobileBreakpoint) {
      this.setState({ mobileImageHeight: Math.ceil(width / 2.5) });
    }
  };

  render() {
    const {
      title,
      description,
      image,
      currency,
      buttonLabel,
      buttonStyle,
      placeholder,
      onSubmit,
      value,
      inputValidators,
      inputParsers,
      wrapperSection,
      behaviorSettings,
      uuid,
    } = this.props;
    const { mobileImageHeight } = this.state;

    const classes = [
      'bb',
      'bb-quick-donate-widget',
      styles['bb-quick-donate-widget'],
      wrapperSection,
      generateClassNameByBehaviorSettings(behaviorSettings),
    ];

    return (
      <div className={classes.join(' ')} id={uuid}>
        <div className="container">
          <div className={styles['wrapper-container']}>
            <img
              src={image.url}
              alt={image.alt}
              style={{ height: mobileImageHeight }}
              width={264}
              height={188}
            />

            <div
              className="image"
              style={{ backgroundImage: `url("${image.url}")` }}
              title={image.alt}
            />

            <div className="wrapper">
              {title && <div className="header-two rockitt">{title}</div>}

              {description && <FormattedText className="text" text={description} />}

              <TextFieldButton
                currency={currency}
                buttonLabel={buttonLabel}
                placeholder={placeholder}
                onSubmit={onSubmit}
                inputParsers={inputParsers}
                inputValidators={inputValidators}
                value={value}
                withArrow
                type={buttonStyle}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

BBQuickDonateWidget.propTypes = {
  currency: PropTypes.oneOf(['GBP', 'EUR']).isRequired,
  onSubmit: PropTypes.func.isRequired,
  value: PropTypes.number,
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.shape({
    url: PropTypes.string,
    alt: PropTypes.string,
  }).isRequired,
  placeholder: PropTypes.string,
  buttonLabel: PropTypes.string,
  buttonStyle: PropTypes.string,
  inputValidators: PropTypes.arrayOf(PropTypes.func),
  inputParsers: PropTypes.arrayOf(PropTypes.func),
  wrapperSection: PropTypes.string,
  behaviorSettings: behaviorSettingsProps,
  uuid: PropTypes.string,
};

BBQuickDonateWidget.defaultProps = {
  value: null,
  title: 'I want to donate',
  description: null,
  placeholder: 'Enter amount',
  buttonLabel: 'Donate',
  buttonStyle: 'primary',
  inputValidators: null,
  inputParsers: [],
  wrapperSection: '',
  behaviorSettings: null,
  uuid: null,
};

export default BBQuickDonateWidget;
